// Event Emitter
const _callbacks = {};

const contains = (arr, ele) => {
  return arr.includes(ele);
};

const EventManager = {
  on: (eventName, fn) => {
    if (!eventName || !fn) return;

    if (!_callbacks[eventName]) {
      _callbacks[eventName] = [];
    }

    const target = _callbacks[eventName];

    if (!contains(target, fn)) {
      target.push(fn);
    }
  },
  off: (eventName, fn) => {
    if (!eventName || !fn) return;

    const target = _callbacks[eventName];

    if (target && contains(target, fn)) {
      _callbacks[eventName] = target.filter((f) => f !== fn);

      // Clean Up if last element
      if (_callbacks[eventName].length === 0) {
        delete _callbacks[eventName];
      }
    }
  },
  emit: (eventName, message) => {
    if (!eventName) return;

    const target = _callbacks[eventName];

    if (target) {
      target.forEach((fn) => {
        fn(message);
      });
    }
  }
};

export default EventManager;
